import { siteApiSlice } from "../../../../app/siteApiSlice";
import { AdminReportsResponse, AdminReportsRowBase } from "../adminReportsApiSlice";

interface HolisticAndTraitScoresBase {
	averageDevelopment: number;
	averageOrganization: number;
	averageStyle: number;
	averageWordChoice: number;
	averageSentenceStructure: number;
	averageConventions: number;
	averageTotalScore: number;
}

export interface HolisticAndTraitScoresRow
	extends AdminReportsRowBase,
		HolisticAndTraitScoresBase {}

export interface HolisticAndTraitScoresResponse {
	lastUpdateDate?: Date;
	response: AdminReportsResponse<HolisticAndTraitScoresRow>;
}

export interface HolisticAndTraitScoresByGenreRow extends HolisticAndTraitScoresBase {
	courseId: number;
	courseName: string;
	teachers: string;
	genreId: number;
	genreName: string;
	studentCount: number;
	averagePercentileRank?: number;
	stanine?: number;
}

export interface HolisticAndTraitScoresByGenreResponse {
	lastUpdateDate?: Date;
	response: AdminReportsResponse<HolisticAndTraitScoresByGenreRow>;
}

export interface CoreWritingStandardRow extends AdminReportsRowBase {
	averageArgumentative: number;
	averageInformativeExplanatory: number;
	averageNarrative: number;
	average: number;
}

export interface CoreWritingStandardResponse {
	lastUpdateDate?: Date;
	response: AdminReportsResponse<CoreWritingStandardRow>;
}

export const adminPerformanceReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		holisticAndTraitScores: build.query<
			HolisticAndTraitScoresResponse,
			{ districtId?: number; schoolId?: number }
		>({
			query: (arg) => {
				const { districtId, schoolId } = arg;
				return {
					url: `/AdminReports/HolisticAndTraitScoresAjaxHandler`,
					params: { districtId, schoolId },
				};
			},
		}),
		holisticAndTraitScoresByGenre: build.query<
			HolisticAndTraitScoresByGenreResponse,
			{ districtId?: number; schoolId?: number }
		>({
			query: (arg) => {
				const { districtId, schoolId } = arg;
				return {
					url: `/AdminReports/HolisticAndTraitScoresByGenreAjaxHandler`,
					params: { districtId, schoolId },
				};
			},
		}),
		averageScoresByGenre: build.query<
			CoreWritingStandardResponse,
			{ districtId?: number; schoolId?: number }
		>({
			query: (arg) => {
				const { districtId, schoolId } = arg;
				return {
					url: `/AdminReports/CoreWritingStandardAjaxHandler`,
					params: { districtId, schoolId },
				};
			},
		}),
	}),
});

export const {
	useLazyHolisticAndTraitScoresQuery,
	useLazyHolisticAndTraitScoresByGenreQuery,
	useLazyAverageScoresByGenreQuery,
} = adminPerformanceReportApiSlice;
